module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span')]), _vm._v(" "), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("PREFACE "), _c('i', [_vm._v("to the")]), _c('br'), _vm._v("\n    SECOND EDITION")])]), _vm._v(" "), _c('figure', {
    staticClass: "figbas",
    attrs: {
      "id": "fig-002"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "",
      "src": "images/CH_ding_color.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("T")]), _vm._v("he convictions on which the book was first based, as expressed in the preface to the first edition, are as firm in my mind as they ever were. And they have been strengthened through ongoing teaching on the subject. Wherever I teach on this topic, there is usually a moment of eye-opening fresh insight on Jesus when he is presented in the light of how he saw himself in relation to the Old Testament. Somehow, and not surprisingly, the whole Bible comes to make much more sense when Jesus Christ, as the Bible’s center of unity, is brought into focus in a way that affirms rather than overlooks all that went before him.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This edition of the book has an additional "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap8#chap-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sixth chapter")]), _vm._v(". When I wrote the original book with its "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap3#chap-002a"
    }
  }, [_vm._v("five chapters")]), _vm._v(", I had in mind readers for whom, as for myself, the deity of Jesus of Nazareth is an absolutely solid affirmation of faith and an assumption that author and readers could share. It goes without saying, I thought. Comments I have received from time to time have made it clear that it is dangerous to make that kind of assumption. If it goes without saying, it needs even more to be said! In fact, I have realized that the omission of any discussion of the way in which the Old Testament also shapes what we mean by speaking of Jesus as God was a serious defect of the original book. So I have added this "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap8#chap-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sixth chapter")]), _vm._v(", explaining how the Old Testament reveals the God whom Jesus embodied. Some of the content of the chapter is abbreviated and adapted from my book "), _c('i', [_vm._v("The Mission of God")]), _vm._v(", "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap6#chap-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter four")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("I have added a few questions and exercises at the end of each chapter that I hope may be used either by individuals or by groups.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is pleasing to hear from time to time that the book is being used in a number of institutions of theological education on the list of textbooks for courses in biblical theology—even though it was intended for a more popular readership. For that reason, I have included a few more items in the bibliography at the end for those who wish to study further the whole vast field of historical Jesus research and the Old Testament background to the New Testament. Of these, by far the most significant in my view have been the magisterial works of N. T. (Tom) Wright. With enormous erudition and historical scholarship, he has argued in phenomenal depth for an understanding of Jesus in relation to Israel of the Old Testament and intertestamental period, with which my own much more amateur portrait here is in broad accord. For those who need to study further, most of the books listed provide comprehensive additional bibliography.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I express my thanks to Pieter Kwant and the staff of Langham Literature who have kept encouraging me to believe that this book has an ongoing future. I am delighted that at least part of that future will be within the global fellowship of Langham Partnership.")]), _vm._v(" "), _c('p', {
    staticClass: "sign"
  }, [_c('i', [_vm._v("Chris Wright")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("March 2014")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 69
// module chunks = 0